import React from 'react';

import { BackdropProps } from '@mui/material';

export interface ICustomBackdropProps extends BackdropProps {
  handleClose?: (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => void;
}

const CustomBackdrop = ({ handleClose }: ICustomBackdropProps) => {
  return <button onClick={handleClose} className="modal-backdrop" data-testid="custom-backdrop"></button>;
};

export default CustomBackdrop;
